<template>
  <div class="mfp-with-anim mfp-hide mfp-dialog clearfix" id="nav-login-dialog">
    <h3 class="widget-title">Member Login</h3>
    <p>Welcome back, friend. Login to get started</p>
    <hr />
    <form>
      <div class="form-group">
        <label>Email or Username</label>
        <input v-model="login" class="form-control" type="text" />
      </div>
      <div class="form-group">
        <label>Password</label>
        <input v-model="password" class="form-control" type="password" />
      </div>
      <div class="checkbox">
        <label>
          <input class="i-check" type="checkbox" />Remember Me
        </label>
      </div>
      <!-- <button class="btn btn-primary" @click="onSubmit">
                    Sign In
      </button>-->
      <div v-if="error != ''" class="alert alert-danger">
        <label>{{error}}</label>
      </div>
      <input class="btn btn-primary" @click="onSubmit" readonly value="Sign In" />
    </form>
    <div class="gap gap-small"></div>
    <ul class="list-inline">
      <li>
        <a href="#nav-account-dialog" class="popup-text">Not Member Yet</a>
      </li>
      <li>
        <a href="#nav-pwd-dialog" class="popup-text">Forgot Password?</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
import eventBus from "@/lib/eventBus";

export default {
  data() {
    return {
      login: null,
      password: "",
      error: ""
    };
  },
  computed: {
    ...mapState("user", ["userDetails"])
  },
  created() {
    eventBus.$on("user.registered", value => {
      this.login = value;
      //console.log(value)
    });
  },
  methods: {
    async onSubmit() {
      this.error = "";
      await this.$store.dispatch("user/login", {
        login: this.login,
        password: this.password
      });
      //console.log('userDetails ::::::::::::::::: ',  this.userDetails);
      if (this.userDetails) {
        $.magnificPopup.close();
        window.location.reload();
      } else {
        this.error = "Invalid Username or Password";
        //console.log('invalid login ::::::::::::::::: ');
      }
    }
  }
};
</script>
